import React from 'react';
import Header from './Header';

export default function CommonHeader() {
    return <Header />;
}
